import React from 'react';
import uisFetch from '../../utils/uisFetch';
import { fetchAndConvertToBase64 } from '../../utils/FileUtils';

function stripSurroundingQuotes(filename) {
    if (typeof filename !== 'string') {
        return filename;
    }

    if (filename.length >= 2 &&
        filename.startsWith('"') &&
        filename.endsWith('"')) {
        return filename.substring(1, filename.length - 1);
    }

    return filename;
}

class Measurement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            OTP: "",
            OTPInputAlert: "",
            summary: {
                Id: 0,
                StaffERN: "",
                LastName: "",
                FirstName: "",
                PreferredName: "",
                Position: "",
                DetailList: []
            },
            SubmitAlert: "",
            IsGrpByUnifCode: true,
            IsTabletView: Boolean,
            IsMobileView: Boolean,
            modelTitle: '',
            modelImgIds: {},
            modelUniformID: '',
            measurementImages: {}, // Store Base64 images
            loadingImages: {}, // Loading state for images
            imageLoadTimestamps: {} // Image load timestamps
        }
        
        // Anti-duplicate request cooldown period (milliseconds)
        this.REQUEST_COOLDOWN = 5000; // 5 seconds
    }
    componentWillUnmount() {
        this.setState({
            measurementImages: {},
            loadingImages: {},
            imageLoadTimestamps: {}
        });
    }
    componentDidMount() {
        // Check permission first
        if (this.props.hasPermission === false) {
            // No permission, redirect to home page
            window.location.href = process.env.PUBLIC_URL || "/";
            return;
        }

        this.setState({ OTP: "" });
        if (window.$) $('#inpOTP').focus();

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let defaultOTP = params.get('OTP');
        if (defaultOTP != null) {
            this.setState({ OTP: defaultOTP }, () => {
                this.forceUpdate();
                this.Proceed(true);
            });
        }

        this.setState({ IsMobileView: window.innerWidth <= 1024 });
        this.setState({ IsTabletView: window.innerWidth >= 768 });
        window.addEventListener('resize', () => {
            this.setState({
                IsMobileView: window.innerWidth <= 1024,
                IsTabletView: window.innerWidth >= 768
            });
        }, false);
    }

    UpdateOTP(e) {
        this.setState({ OTP: e.target.value });
    }

    Go(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.Proceed(true);
        }
    }

    PassParmToModel(unifName, UniformId, imgIds) {
        this.setState({ modelTitle: unifName, modelUniformID: UniformId, modelImgIds: imgIds });
    }

    handleGrpByUnifChange(e) {
        const value = !this.state.IsGrpByUnifCode;
        this.setState({ IsGrpByUnifCode: value }, () => { this.Proceed(false); });
    }

    Proceed = (firstTime) => {
        this.setState({ OTPInputAlert: "" });
        if (!this.state.OTP) {
            this.setState({ OTPInputAlert: "Please input valid PIN" });
            return;
        }
        const url = this.props.apiprefix + 'pubmeagetsummary?OTP=' + this.state.OTP + '&IsGrpByUnifCode=' + this.state.IsGrpByUnifCode;
        uisFetch(this.props.accessToken,url, {
            method: "GET"
        }).then((response) => response.json())
            .then((result) => {
                if (this.props.debug) console.log("[Public] pubmeagetsummary - result = ", result);
                if (!result) {
                    this.setState({ OTPInputAlert: "No Measurement Form returned. Please Try Again" });
                    return;
                }
                this.setState({ summary: result });
                if (firstTime && window.$) $('#btnProceed').click();
            });
    }

    Submit = () => {
        this.setState({ SubmitAlert: "" });
        if (window.$) {
            $("#SubmitAlert").removeClass('text-success');
            $("#SubmitAlert").removeClass('text-warning');
        }
        const url = this.props.apiprefix + (this.state.IsGrpByUnifCode ? 'pubmeasavedetailswithgrpbyumn' : 'pubmeasavedetails');
        uisFetch(this.props.accessToken,url, {
            method: "POST",
            headers: {
                "Content-type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(Object.values(this.state.summary.DetailList))
        }).then((response) => response.text())
            .then((result) => {
                if (this.props.debug) console.log("[Public] pubmeasavedetails - result = ", result);
                if (window.$) {
                    if (result === "Success")
                        $("#SubmitAlert").addClass('text-success');
                    else
                        $("#SubmitAlert").addClass('text-warning');
                }
                this.setState({ SubmitAlert: result });
                if (result === "Success" && window.$) {
                    $('#btnSuccess').click();
                    setTimeout(() => {
                        window.location.href = process.env.PUBLIC_URL || "/";
                    }, 5000);
                }
            });
    }

    ResetAll = () => {
        // Do not mutate state directly, use deep copy
        const summary = { ...this.state.summary };
        summary.DetailList = summary.DetailList.map(item => ({ ...item, SelectedSubCodeId: 0 }));
        this.setState({ summary });
    }

    setSubCodeOptionsActive(e, m) {
        // Do not mutate state directly, use deep copy
        const summary = { ...this.state.summary };
        summary.DetailList = summary.DetailList.map(item => {
            if (item === m) {
                return { ...item, SelectedSubCodeId: e.target.value };
            }
            return item;
        });
        this.setState({ summary });
    }

    async loadMeasurementImage(uniformId, imgId) {
        const key = `${uniformId}_${imgId}`;
        const now = Date.now();
        
        // If already have data, return directly
        if (this.state.measurementImages[key]) {
            return;
        }
        
        // If currently loading, return directly
        if (this.state.loadingImages[key]) {
            return;
        }
        
        // Check if within cooldown period
        const lastLoadTime = this.state.imageLoadTimestamps[key];
        if (lastLoadTime && (now - lastLoadTime) < this.REQUEST_COOLDOWN) {
            return;
        }
        
        // Set loading state and timestamp
        this.setState(prevState => ({
            loadingImages: {
                ...prevState.loadingImages,
                [key]: true
            },
            imageLoadTimestamps: {
                ...prevState.imageLoadTimestamps,
                [key]: now
            }
        }));
        
        try {
            const url = `${this.props.apiprefix}getimage?unm=${uniformId}&uni=${imgId}`;
            const base64Data = await fetchAndConvertToBase64(url, this.props.accessToken);
            
            if (base64Data) {
                this.setState((prevState) => ({
                    measurementImages: {
                        ...prevState.measurementImages,
                        [key]: base64Data,
                    },
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            }
        } catch (error) {
            console.error(`load measurement image error ${key}:`, error);
            this.setState(prevState => ({
                loadingImages: {
                    ...prevState.loadingImages,
                    [key]: false
                }
            }));
        }
    }

    renderMeasurementSummary() {
        let DetailList = this.state.summary.DetailList == null ? null : this.state.summary.DetailList.map( (m, idx) => {

            // Do not mutate m directly

            let subCodeOptions = m.SubCodeList;
            let domSubCodeOptions;
            if (subCodeOptions)
                domSubCodeOptions = Object.keys(subCodeOptions).map((n) => {
                    if (!this.state.IsMobileView) {
                        return (
                            <option key={subCodeOptions[n].SubCodeID} value={subCodeOptions[n].SubCodeID}>{subCodeOptions[n].SubCode}</option>
                        );
                    } else {
                        return (
                            <button type="button" key={"mob" + subCodeOptions[n].SubCodeID} value={subCodeOptions[n].SubCodeID}
                                className={"btn btn-outline-secondary subCode-btn-options " + (subCodeOptions[n].SubCodeID === m.SelectedSubCodeId ? "active" : "")}
                                onClick={(e) => { this.setSubCodeOptionsActive(e, m) }} >{subCodeOptions[n].SubCode}</button>
                        );
                    }
                });

            if (!this.state.IsMobileView) {
                const _carouselIndId = "carouselInd" + idx;
                // Preload images if not already in state
                if (m.ImageList && m.ImageList.length > 0) {
                    m.ImageList.forEach((m2) => {
                        const key = `${m.UniformId}_${m2.ImgId}`;
                        if (!this.state.measurementImages[key]) {
                            this.loadMeasurementImage(m.UniformId, m2.ImgId);
                        }
                    });
                }
                return (
                    <tr key={idx}>
                        <td className="font-weight-bold align-middle">{m.UniformName} <br /> {m.UniformNameChi}</td>
                        {this.state.IsGrpByUnifCode && <td className="font-weight-bold align-middle">{m.Qty}</td>}
                        <td className="align-middle">
                            {m.ImageList.length > 0 ?
                                <div id={_carouselIndId} className="carousel slide " data-ride="carousel" data-interval="false"  >
                                    <div className="carousel-inner " data-toggle="modal" data-target="#itemImgModal"
                                        onClick={this.PassParmToModel.bind(this, m.UniformName + " " + m.UniformNameChi, m.UniformId, m.ImageList)} >
                                        {
                                            m.ImageList.map((m2, index) => {
                                                const key = `${m.UniformId}_${m2.ImgId}`;
                                                const blobUrl = this.state.measurementImages[key];
                                                return (
                                                    <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index === 0 ? "active" : "")}> 
                                                        <div className="card-header" id={m2.ImgId}>
                                                            <div className="col-12 text-center">
                                                                {(() => {
                                                                    const key = `${m.UniformId}_${m2.ImgId}`;
                                                                    const blobUrl = this.state.measurementImages[key];
                                                                    if (!blobUrl) {
                                                                        this.loadMeasurementImage(m.UniformId, m2.ImgId);
                                                                        return <span>Loading...</span>;
                                                                    }
                                                                    return (
                                                                        <a target="_blank" href={blobUrl} rel="noopener noreferrer" download={stripSurroundingQuotes(m2.ImgFileName)}>
                                                                            <img className="img-thumbnail" src={blobUrl} alt="Card image cap" style={{ cursor: 'default', maxHeight: "225px", maxWidth: "225px" }} />
                                                                        </a>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    {m.ImageList.length > 1 &&
                                        <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                            <span className="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    }
                                    {m.ImageList.length > 1 &&
                                        <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                            <span className="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    }
                                </div>
                                :
                                <div className="d-flex justify-content-center">
                                    <img name={m.Seq}
                                        src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                        width='100%' className="img-thumbnail w-100" style={{ maxHeight: "100", maxWidth: "100px", margin: "0 auto" }}
                                    />
                                </div>
                            }
                        </td>
                        <td className="font-weight-bold align-middle">
                            <select value={m.SelectedSubCodeId} className="form-control font-weight-bold" onChange={(e) => this.setSubCodeOptionsActive(e, m)} >
                                <option key='0' defaultValue='0' value='0' >Select Sub-Code</option>
                                {domSubCodeOptions}
                            </select>
                        </td>
                    </tr>
                )
            } else {
                const _accordionId = "accordion" + idx;
                const _headingId = "heading" + idx;
                const _collapseId = "collapse" + idx;
                const _carouselIndId = "carouselInd" + idx;
                return (
                    <div className="card shadow rounded mt-3" key={_accordionId + _headingId} id={_accordionId}>
                        <div className="card-header cardView-header-bg-Color" id={_headingId}>
                            <h5 className="mb-0 cardView-header-link" style={{ textAlign: 'left' }}>
                                <a className="btn btn-link w-100" data-toggle="collapse" data-target={'#' + _collapseId} aria-expanded="true" aria-controls={_collapseId}>
                                    <label className={"card-text h5 font-weight-bold "}>{m.UniformName} <br /> {m.UniformNameChi}</label>
                                </a>
                            </h5>
                        </div>
                        <div id={_collapseId} className="collapse show" aria-labelledby={_headingId} data-parent={'#' + _accordionId}>
                            <div className="card-body cardView-body-bg-Color text-sm-left ">
                                <div className="row no-gutters">
                                    <div className={"col-md-4 d-flex justify-content-center my-auto"}>
                                        {m.ImageList.length > 0 ?
                                            <div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false"  >
                                                <div className="carousel-inner " data-toggle="modal" data-target="#itemImgModal"
                                                    onClick={this.PassParmToModel.bind(this, m.UniformName + " " + m.UniformNameChi, m.UniformId, m.ImageList)}  >
                                                    {
                                                        m.ImageList.map((m2, index) => (
                                                            <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index === 0 ? "active" : "")}>
                                                                {(() => {
                                                                    const key = `${m.UniformId}_${m2.ImgId}`;
                                                                    const blobUrl = this.state.measurementImages[key];
                                                                    if (!blobUrl) {
                                                                        this.loadMeasurementImage(m.UniformId, m2.ImgId);
                                                                        return <span>Loading...</span>;
                                                                    }
                                                                    return (
                                                                            <img  src={blobUrl} className="d-block w-100 img-thumbnail"
                                                                                style={{ maxHeight: "225px", maxWidth: "225px" }} />
                                                                    );
                                                                })()}
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                {m.ImageList.length > 1 &&
                                                    <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                                        <span className="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
                                                        <span className="sr-only">Previous</span>
                                                    </a>
                                                }
                                                {m.ImageList.length > 1 &&
                                                    <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                                        <span className="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
                                                        <span className="sr-only">Next</span>
                                                    </a>
                                                }
                                            </div>
                                            :
                                            <img name={m.Seq}
                                                src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                width='100%' className="img-thumbnail w-100" style={{ maxHeight: "225px", maxWidth: "225px" }}
                                            />
                                        }
                                    </div>
                                    <div className="col d-none d-md-block mr-4" style={{ borderRight: "2px solid #a7a6a6" }} ></div>
                                    <div className="col col-12 d-md-none d-lg-none mt-4" style={{ borderBottom: "2px solid #a7a6a6" }} ></div>
                                    {this.state.IsGrpByUnifCode &&
                                        <div className="form-group col-md-2 mt-3 mt-md-0">
                                            <small className="row card-text ml-1 mb-1">Qty 數量</small>
                                            {m.Qty}
                                        </div>
                                    }
                                    {this.state.IsGrpByUnifCode &&
                                        <div className="col d-none d-md-block mr-4" style={{ borderRight: "2px solid #a7a6a6" }} ></div>
                                    }
                                    {this.state.IsGrpByUnifCode &&
                                        <div className="col col-12 d-md-none d-lg-none mt-4" style={{ borderBottom: "2px solid #a7a6a6" }} ></div>
                                    }
                                    <div className={this.state.IsGrpByUnifCode ? "form-group col-md-5 mt-3 mt-md-0" : "form-group col-md-7 mt-3 mt-md-0"}>
                                        <small className="row card-text ml-1 mb-1">Size 尺碼</small>
                                        {domSubCodeOptions}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        });

        return (
            <div className={"card-body " + (this.state.IsMobileView ? "card-body-wider" : "")}>
                <div style={this.state.IsMobileView ? { padding: "20px", paddingBottom: "0px" } : {}}>
                    <div className="form-row">
                        <div className="col-sm-3">
                            <label>Staff 姓名: </label>
                        </div>
                        <div className="col-sm-7 font-weight-bold">
                            {this.state.summary.LastName + ' ' + this.state.summary.FirstName + (this.state.summary.PreferredName ? ', ' + this.state.summary.PreferredName : '') + '(' + this.state.summary.StaffERN + ')'}
                        </div>
                    </div>
                    <br />
                    <div className="form-row">
                        <div className="col-sm-3">
                            <label>Position 職位: </label>
                        </div>
                        <div className="col-sm-7 font-weight-bold">{this.state.summary.Position}</div>
                    </div>
                </div>
                <hr />
                <div className="form-row">
                    <div className="col">
                        <label className={"pl-1"}>Requested Item(s) 需量度的制服: </label>
                        <img id="btnGrp" src={this.state.IsGrpByUnifCode ? `${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-465-server-plus.png` : `${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-466-server-minus.png`} onClick={this.handleGrpByUnifChange.bind(this)} style={{ float: "right" }} title="Group By Uniform - 按制服分組" />
                        {this.state.IsMobileView === false ? (
                            <div className="tableFixHead table-responsive" style={{ maxHeight: "430px", height: "fit-content" }}>
                                <table className="table table-striped dt-responsive w-100" >
                                    <tbody>
                                        {DetailList}
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th scope="col">Uniform 制服</th>
                                            {this.state.IsGrpByUnifCode && <th scope="col">Qty 數量</th>}
                                            <th scope="col">Image 制服圖片</th>
                                            <th scope="col">Size 尺碼</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        ) : (
                            <div className="mt-2">
                                {DetailList}
                            </div>
                        )}
                    </div>
                </div>
                <br />
                <div className="form-row d-flex">
                    <div className="mx-auto">
                        <div className="row">
                            <a id="btnSubmit" className="btn btn-primary text-white" onClick={this.Submit.bind(this)} hidden={this.state.SubmitAlert === "Success"}>Submit 提交</a>
                            <span>&nbsp;</span>
                            <a className="btn btn-danger text-white" onClick={this.ResetAll.bind(this)} hidden={this.state.SubmitAlert === "Success"}>Reset 重置</a>
                            <span>&nbsp;</span>
                            <div id="SubmitAlert" className="font-weight-bold">{this.state.SubmitAlert}</div>
                            <a id="btnSuccess" className="btn btn-info" hidden data-toggle="collapse" href="#collapseThree" role="button" aria-expanded="false" aria-controls="collapseThree">HIDDEN</a>
                        </div>
                        <span>&#xA0;</span>
                    </div>
                </div>
            </div>
        );
    }

    renderItemImgModal() {
        return (
            <div className="modal fade" id='itemImgModal' role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-body-autoHeight">
                            {this.state.modelImgIds && this.state.modelImgIds.length > 0 ? (
                                <div id="_carouselIndId" className="carousel slide" data-ride="carousel" data-interval="false">
                                    <div className="carousel-inner">
                                        {this.state.modelImgIds.map((m, index) => {
                                            const attachmentUrl = this.props.apiprefix + "uniformdownloadattachement?unm=" + this.state.modelUniformID + "&uni=" + m.ImgId;
                                            const key = this.state.modelUniformID + '_' + m.ImgId;;
                                            const blobUrl = this.state.measurementImages[key];
                                            return (
                                                <div key={"modelImg" + index} className={"carousel-item " + (index === 0 ? "active" : "")}>
                                                    <div className="card">
                                                        <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                                                            {m.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0 ? (
                                                                    
                                                                        <a target="_blank" href={blobUrl} rel="noopener noreferrer" download={stripSurroundingQuotes(m.ImgFileName)}>
                                                                            <img className="img-thumbnail" src={blobUrl} alt="Card image cap" style={{ cursor: 'default' }} />
                                                                        </a>
                                                                   
                                                                ) : (
                                                                    
                                                                        <div className="card-img-top image1" style={{cursor: 'default'} }>
                                                                            <a className="card-img-top image1" href={blobUrl} alt="Card image cap" download={stripSurroundingQuotes(m.ImgFileName)}>
                                                                                Preview: {m.ImgFileName}
                                                                            </a>
                                                                        </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    {this.state.modelImgIds.length > 1 &&
                                        <a className="carousel-control-prev" href="#_carouselIndId" role="button" data-slide="prev">
                                            <span className="carousel-control-prev-icon carousel-control-shape" aria-hidden="true"></span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    }
                                    {this.state.modelImgIds.length > 1 &&
                                        <a className="carousel-control-next" href="#_carouselIndId" role="button" data-slide="next">
                                            <span className="carousel-control-next-icon carousel-control-shape" aria-hidden="true"></span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    }
                                </div>
                            ) : (
                                <img src={`${process.env.PUBLIC_URL}/Images/no-image.png`} width='100%' className="img-thumbnail w-100" />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="container bg-secondary " style={{ minHeight: '100vh' }} >
                <div className="gap-line" />
                <div className="col-12" style={this.state.IsMobileView ? { paddingLeft: "5px", paddingRight: "5px" } : {}}>
                    <br style={this.state.IsMobileView ? { display: "none" } : {}} />
                    <div id="application-card" className="card border-light bg-light" style={{ minHeight: '95vh' }}>
                        <div id="application-card-header" className="card-header text-white">
                            <div className="d-flex">
                                <div className="mr-auto"><label className={this.state.IsTabletView === false ? "h5" : " h4"}>UIS - Measurement Form 尺碼量度表</label></div>
                                <div>
                                    <a className="btn btn-secondary center-block" href={`${process.env.PUBLIC_URL}/home`} role="button"><img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-21-home.png`} width='30px' /></a>
                                </div>
                            </div>
                        </div>
                        <div className={"card-body " + (this.state.IsMobileView ? "card-body-wider" : "")}>
                            <div className="form-group">
                                <div className="accordion" id="accordionExample">
                                    <div className="card">
                                        <form>
                                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                <div className="card-body">
                                                    <div className="d-flex">
                                                        <div className="mx-auto">
                                                            <div className="form-row">
                                                                <h2 className="w-100 text-center">Please Type in PIN for Your Uniform Measurement<br />請將認證碼輸入在以下空格內</h2>
                                                            </div>
                                                            <div className="form-row">
                                                                <label className="col-form-label">PIN 認證碼: </label>
                                                                <input id="inpOTP" type="number" pattern="[0-9]*" inputMode="numeric" className="form-control" defaultValue={this.state.OTP} onKeyPress={(e) => this.Go(e)} onInput={(e) => this.UpdateOTP(e)} style={{ maxWidth: '100%', whiteSpace: 'pre-line', position: 'relative' }} />
                                                            </div>
                                                            <div className="form-row">
                                                                <a id="btnContinue" className="btn btn-info text-white" onClick={this.Proceed.bind(this)}>Continue 下一步</a>
                                                                <span>&nbsp;</span>
                                                                <div className="font-weight-bold text-danger">{this.state.OTPInputAlert}</div>
                                                                <a id="btnProceed" className="btn btn-info" hidden data-toggle="collapse" href="#collapseTwo" role="button" aria-expanded="false" aria-controls="collapseTwo">HIDDEN</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="card">
                                        {this.renderItemImgModal()}
                                        <form>
                                            <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample" style={{ maxHeight: '90vh', overflowY: 'scroll' }}>
                                                {this.renderMeasurementSummary()}
                                            </div>
                                            <a id="btnBottom" href="#btnSubmit" style={this.state.IsMobileView ? {} : { display: 'none' }}>V</a>
                                        </form>
                                    </div>
                                    <div className="card">
                                        <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                            <div className="card-body">
                                                <div className="d-flex">
                                                    <div className="mx-auto">
                                                        <div className="text-success"><h2>Success 完成</h2></div>
                                                        <div>系統將於5秒後返回首頁</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Measurement;
